import { useDataSubmit, useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'selected',
    path: 'bulk_task_ids',
    viewPath: props.viewPath,
  })

  let stage_id = useDataValue({
    context: 'stage',
    path: 'id',
    viewPath: props.viewPath,
  })

  let bulk_task_ids = useDataValue({
    context: 'selected',
    path: 'bulk_task_ids',
    viewPath: props.viewPath,
  })

  let filtered_tasks = useDataValue({
    context: 'selected',
    path: 'filtered_tasks',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({
      type: 'set_bulk_tasks_stage',
      task_and_stage_ids: filtered_tasks
        // take out tasks already in that stage
        .filter(
          item => bulk_task_ids.includes(item.id) && item.stage.id !== stage_id
        )
        .map(task => ({
          id: task.id,
          stage_id,
        })),
    })

    change([])
  }
}
